// Import VueRouter
import VueRouter from 'vue-router'

// Import pages
import HomePage from '../pages/HomePage'
import PublicationPage from '../pages/PublicationPage'
import PhotographyPage from '../pages/PhotographyPage'
import BlogPage from '../pages/BlogPage'

const router = new VueRouter({
    mode: "history",
    base: process.env.NODE_ENV === 'production' ? '/DonaldLamNL/' : '/',
    routes:[
        {
            path: '/',
            redirect: '/home'
        },
        {
            // Home Page
            name: 'Home',
            component: HomePage,
            path: '/home',
            meta: {
                sections: [
                    { id: 'introduction', name:'Introduction'},
                    { id: 'news', name:'News'},
                    { id: 'experience', name:'Experience'},
                    { id: 'scholarships', name:'Scholarships'},
                    { id: 'services', name:'Services'},
                    // { id: 'timetable', name:'Timetable'},
                ]
            }
        },
        {
            // Academic Page
            name: 'Publication',
            component: PublicationPage,
            path: '/publication',
            meta: {
                sections: [
                    { id: 'publication-list', name: 'Publication' },
                    { id: 'preprint-list', name: 'Preprint' },
                ]
            }
        },
        {
            // Learning Page
            name: 'Photography',
            component: PhotographyPage,
            path: '/photography',
            meta: {
                sections: [
                    { id: 'album', name: 'Album' },
                    // { id: 'learning-project', name: 'Projects' },
                ]
            }
        },
        {
            // Blog Page
            name: 'Blog',
            component: BlogPage,
            path: '/blog',
        },

    ],
    scrollBehavior (to, from, savedPosition) {
        if(savedPosition){
            return savedPosition
        }else{
            return {x: 0, y: 0}
        }
    }
})

router.beforeEach((to, from, next) => {
    if(to.name === 'Blog'){
        window.location.href = 'https://donaldlamnl.github.io/myBlog/'
    }else{
        next()
    }
})

export default router